import React from "react";

function PageLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900">
      <div className="mx-auto max-w-4xl px-6 py-16 sm:py-24">
        {title && (
          <div className="mb-12">
            <h1 className="mb-4 text-4xl font-bold text-white sm:text-5xl">
              {title}
            </h1>
            {subtitle && (
              <p className="text-lg text-slate-300">{subtitle}</p>
            )}
          </div>
        )}
        <div className="prose prose-invert max-w-none">
          {children}
        </div>
      </div>
    </div>
  );
}

export default PageLayout;
